import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9 13h2v-2.75h2V13h2V8.25l-3-2-3 2zm3 6.35q3.05-2.8 4.525-5.088Q18 11.975 18 10.2q0-2.725-1.738-4.462Q14.525 4 12 4T7.737 5.737Q6.001 7.475 6 10.2q0 1.775 1.475 4.063Q8.95 16.549 12 19.35m0 1.975a2.1 2.1 0 0 1-.7-.125 1.8 1.8 0 0 1-.625-.375A39 39 0 0 1 7.8 17.9q-1.25-1.425-2.087-2.762-.838-1.338-1.276-2.575Q4 11.325 4 10.2q0-3.75 2.412-5.975T12 2c3.175 0 3.98.742 5.587 2.225Q20.001 6.45 20 10.2q0 1.125-.438 2.363-.437 1.237-1.274 2.574A21.7 21.7 0 0 1 16.2 17.9a39 39 0 0 1-2.875 2.925 1.8 1.8 0 0 1-.625.375 2.1 2.1 0 0 1-.7.125" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }